/** Türkçe sözlük · izleme. Şekli bu dosya tanımlar; öteki diller ona bağlıdır. */
export const izleme = {
  /** İzleme ekranı (`screens/TrackingScreen.tsx`). */
  ekran: {
    baslik: "İzleme",
    aciklama: "Merkezin bu araçlar için nerede olduğu. Dolmamış dönem için rapor değer üretmez.",
    sahteBaslik: "Sahte merkez",
    sahteOnce: "Bu koşumda gerçek merkeze bağlanılmadı (",
    sahteSonra: "). Buradaki durumlar uydurma; gerçek veri değil.",
    merkezYokBaslik: "Merkeze ulaşılamıyor",
    merkezYokMetin:
      "Hareket girmek, kasayı okumak ve pozisyonları görmek merkeze bağlı değil — onlar çalışmaya devam ediyor. Merkez geri geldiğinde bu ekran kendini günceller.",
    onbellekYokBaslik: "Fiyat önbelleği bağlı değil",
    onbellekYokMetin: "İzleme durumu okunamıyor.",
    hareketlerOkunamadi: "Hareketler okunamadı",
    hareketlerOkunuyor: "Hareketler okunuyor…",
    aracYokBaslik: "İzlenen araç yok",
    aracYokMetin:
      "Bir hareketi merkezden izlenen bir araca bağladığınızda merkez onu izlemeye alır " +
      "ve on yıllık geçmişini arkada doldurur. Durumu burada göreceksiniz.",
    durumOkunamadi: "İzleme durumu okunamadı",
    durumOkunuyor: "İzleme durumu okunuyor…",
  },
  /** Bir aracın satırı. */
  satir: {
    onbellekKaydiYok:
      "Bu cihazda bu araca ait önbellek kaydı yok. Eşitleme çalıştırıldığında merkezden durumu ve fiyatları gelir. (Merkezin bu aracı izlemediği anlamına GELMEZ.)",
    paraBirimiBilinmiyor: "para birimi bilinmiyor",
    elleFiyatBaglanti: "Elle fiyat",
    elleFiyatSonEk: "ekranından bu araç kimliği için fiyat girebilirsiniz.",
    buCihazda: "Bu cihazda",
    fiyatYok: "fiyat yok",
    barSayisi: "Bar sayısı",
    merkezde: "Merkezde",
    bilinmiyor: "bilinmiyor",
    sonEsitleme: "Son eşitleme",
    hic: "hiç",
    sonHata: (hata: string) => `Son hata: ${hata}`,
  },
  /** Geçmiş doldurma ilerlemesi. */
  gecmis: {
    ufukBilinmiyor: "Geçmiş ufku henüz bilinmiyor — merkez aracın ihraç tarihini öğrenince belirlenir.",
    baslamadi: "Geçmiş doldurma henüz başlamadı",
    ufuk: (tarih: string) => ` (ufuk: ${tarih})`,
    tam: (tarih: string) => `Geçmiş ${tarih} tarihine kadar tam.`,
    ilerlemeEtiketi: "Geçmiş doldurma ilerlemesi",
    kismi: (tarih: string, yuzde: string) =>
      `${tarih} tarihine kadar dolu (${yuzde}). Daha eski dönem için rapor değer üretmez.`,
  },
  /** Eşitleme düğmesi ve son eşitlemenin özeti. */
  esitleme: {
    esitleniyor: "Eşitleniyor…",
    merkezdenEsitle: "Merkezden eşitle",
    sonEsitleme: "Son eşitleme",
    sonEsitlemeAn: (zaman: string, sebep: string) => `Son eşitleme ${zaman} (${sebep})`,
    kurSatir: (n: string) => ` · kur: ${n} satır yazıldı`,
    hatalar: (liste: string) => `Hatalar: ${liste}`,
    dahaFazla: (n: number) => ` ve ${n} tane daha`,
    ozet: (cagri: number, bar: string, ms: number) => `${cagri} çağrı · ${bar} bar yazıldı · ${ms} ms`,
    zatenGuncel: (n: number) => ` · ${n} araç zaten güncel`,
    kaliciEksik: (liste: string) => `Kalıcı eksik (merkezde de yok, beklemek düzeltmez): ${liste}`,
    reddedildi: (n: number) => `${n} bar reddedildi — biçim ya da aralık dışı.`,
    /** Sanal hesap / kıyas eşitlemesinin uyarı önekleri (`lib/aracEsitle.ts`). */
    fiyatHatasi: (mesaj: string) => `fiyat: ${mesaj}`,
    kurHatasi: (mesaj: string) => `kur: ${mesaj}`,
  },
  /** İzleme durumları (`lib/trackState.ts`). */
  durum: {
    ufukHedef: "Ufuk on yıllık hedefte: daha eskisi zaten istenmiyor.",
    ufukIhrac:
      "Ufuk aracın ihraç tarihinde başlıyor — öncesinde veri yok çünkü araç " +
      "henüz yoktu. Bu bir eksiklik DEĞİL.",
    ufukKaynak:
      "Ufuk kaynağın arşiv derinliğiyle sınırlı: bu tarihten öncesi için " +
      "fiyatlar piyasada vardı ama kaynak vermiyor. Bu GERÇEK bir eksiklik " +
      "ve raporda işaretli görünür.",
    ufukSebepsiz: "Ufkun niçin o tarihte olduğunu merkez bildirmedi; ufuk tarihi yukarıda yazılı.",
    gecmisKaynak: "Kaynağın verdiği kadar geçmiş",
    gecmis: "Geçmiş",
    pendingBaslik: "Talep alındı",
    pendingAnlam: (saniye: number) =>
      `Merkez bu aracı izlemeye aldı ama henüz fiyat gelmedi. Güncel fiyat genellikle ` +
      `${saniye} saniye içinde hazır olur; geçmiş arkadan gelir.`,
    spotGunIciYokBaslik: "En güncel yayınlanan değer hazır",
    spotBaslik: "Güncel fiyat hazır",
    spotGunIciYokAnlam: (gecmis: string) =>
      "Bu varlık sınıfında gün içi fiyat yoktur, değer günde bir kez yayınlanır; " +
      "elimizdeki en son yayınlanan değer güncel olanıdır, daha tazesi yayınlanmıyor. " +
      `${gecmis} arkada doluyor.`,
    spotAnlam: (gecmis: string) => `Güncel fiyat ve son bir ayın verisi elde. ${gecmis} arkada doluyor.`,
    backfillingBaslik: "Geçmiş hazırlanıyor",
    backfillingAnlam: (gecmis: string, ufuk: string) =>
      `${gecmis}, bugünden geriye doğru doluyor. Dolmamış dönemler için rapor ` +
      `değer üretmez — eksik dönem sıfır sayılmaz. ${ufuk}`,
    readyBaslik: "Geçmiş tam",
    readyAnlam: (ufuk: string) =>
      `Ufuktan bugüne kadarki geçmiş tam. ${ufuk} ` +
      `Bilinen boşluklar varsa kapsam ayrıntısında ayrıca görünüyor.`,
    dormantBaslik: "Yenileme durdu",
    dormantAnlam:
      "Bu araçta canlı hareketiniz kalmadı, merkez yenilemeyi durdurdu. Yeni bir hareket " +
      "girerseniz yeniden uyanır; elinizdeki geçmiş silinmedi.",
    unresolvedBaslik: "Çözülemedi — fiyatı siz gireceksiniz",
    unresolvedAnlam:
      "Hiçbir kaynak bu aracı fiyatlayamadı; beklemek düzeltmez. Yapılacak: Elle fiyat " +
      "ekranından bu araç kimliği için fiyat girin, ya da hareketi elle değerlenen varlığa " +
      "çevirip Elle değerleme ekranından değer girin.",
  },
  /** Eksik dönemin sebebi. */
  eksikSebep: {
    no_cache: "bu cihazda hiç yok — indirilecek",
    before_cached: "önbelleğin başlangıcından önce — indirilecek",
    after_cached: "önbelleğin bitişinden sonra — indirilecek",
    interior_gap: "arada delik — indirilecek",
    known_gap: "merkezde de yok — beklemek düzeltmez",
    outside_central: "merkezin kapsamı dışında — istemek boşuna",
  },
  /** Elle fiyat ekranı (`screens/ManualPricesScreen.tsx`). */
  elleFiyat: {
    baslik: "Elle fiyat",
    aciklama: "Merkezî fiyat kaynağı olmayan araçlar için gün sonu kapanış.",
    asama2Baslik: "Aşama 2'de ne değişecek",
    asama2Once: "İzlenen araçların fiyatları merkezden gelecek. Bu ekran, hiçbir kaynağın çözemediği (",
    asama2Sonra: ") araçlar için kalacak.",
    kimlikleListele: "Araç kimliği ile listele",
    listele: "Listele",
    kimlikGirin: "Bir araç kimliği girin",
    kimlikGirinMetin: "Girilen araç için kayıtlı fiyatlar listelenir.",
    kayitYok: "Bu araç için fiyat kaydı yok",
    tabloBasligi: (ref: string) => `${ref} için elle girilen fiyatlar`,
    tarih: "Tarih",
    kapanis: "Kapanış",
    paraBirimi: "Para birimi",
    kimlikZorunlu: "Araç kimliği zorunlu.",
    tarihZorunlu: "Tarih zorunlu.",
    paraBirimiSecin: "Listeden bir para birimi seçin.",
    izlenenArac:
      "Bu araç izlemede: günlük fiyatı kaynaktan geliyor ve tektir. " +
      "Elle fiyat yalnızca izlenmeyen (elle değerlenen) varlıklar için.",
    formEtiketi: "Elle fiyat girişi",
    fiyatKaydet: "Fiyat kaydet",
    aracKimligi: "Araç kimliği",
    tekrarKayit: "Aynı araç ve tarih için tekrar kaydetmek mevcut değeri değiştirir.",
  },
  /** Elle değerleme ekranı (`screens/ManualValuationsScreen.tsx`). */
  elleDeger: {
    baslik: "Elle değerleme",
    aciklama: "Merkezî fiyat kaynağı olmayan varlıkların belirli bir tarihteki değeri.",
    yukleniyor: "Değerlemeler yükleniyor…",
    kayitYok: "Elle değerleme kaydı yok",
    kayitYokMetin: "Etiket, hareketlerdeki 'elle değerlenen varlık' etiketiyle aynı yazılmalı ki eşleşsin.",
    tabloBasligi: "Elle değerleme kayıtları",
    etiket: "Etiket",
    tarih: "Tarih",
    deger: "Değer",
    not: "Not",
    islem: "İşlem",
    silOnayBaslik: "Değerleme silinsin mi?",
    silOnaySonEk: "kaydı listeden kalkacak (tombstone).",
    etiketZorunlu: "Etiket zorunlu.",
    formEtiketi: "Elle değerleme girişi",
    degerlemeKaydet: "Değerleme kaydet",
    varlikEtiketi: "Varlık etiketi",
    etiketIpucu: "Hareketlerdeki etiketle birebir aynı olmalı.",
    etiketOrnek: "Fiziki gram altın",
    degerlemeTarihi: "Değerleme tarihi",
    paraBirimi: "Para birimi",
    notIpucu: "Değerin kaynağı (kuyumcu alış, son işlem fiyatı…).",
  },
  /** Araç arama (`components/InstrumentSearch.tsx`). */
  arama: {
    devreDisi: "Arama devre dışı",
    merkezeUlasilamiyor: "Merkeze ulaşılamıyor.",
    devreDisiMetin:
      "Araç kimliğini aşağıdan elle yazabilir ya da varlığı elle değerlenen varlık olarak kaydedebilirsiniz — hareket girmek merkeze bağlı değildir.",
    yerTutucu: "THYAO, Türk Hava, ISIN…",
    enAz: (n: number) => `Arama için en az ${n} karakter yazın.`,
    araniyor: "Merkezde aranıyor…",
    ulasilamadiNokta: "Merkeze ulaşılamadı.",
    sorulamadiBos: 'Dış kaynağa şu an sorulamadı — bu "araç yok" demek değil.',
    sorulamadiAdaylar: (n: number) =>
      `${n} aday bulundu, ama dış kaynağa şu an sorulamadı; liste eksik olabilir.`,
    eslesmeYok: "Eşleşen araç bulunamadı.",
    adaylar: (n: number) => `${n} aday bulundu; listeden seçin.`,
    sorulamadiBaslik: "Dış kaynağa şu an sorulamadı",
    sorulamadiMetin:
      "Merkez bu kodu kendi kataloğunda tanımadı ve hisse/ETF kaynağına (Yahoo) şu an soramadı — hız sınırı ya da kaynak hatası. Bir dakika sonra yeniden arayın; aracı elle değerlenen varlık olarak kaydetmeden önce bunu deneyin.",
    ulasilamadi: "Merkeze ulaşılamadı",
    calismiyor:
      "Arama şu an çalışmıyor. Hareketi yine kaydedebilirsiniz: kimliği elle yazın ya da elle değerlenen varlığa geçin.",
    birdenFazlaOnce: "Birden fazla aday var; doğru olanı ",
    birdenFazlaSiz: "siz",
    birdenFazlaSonra: " seçin. Yanlış araca bağlanan bir hareket sonradan en zor fark edilen hatadır.",
    adaylarEtiketi: "Araç adayları",
    paraBirimi: (ad: string) => `Para birimi: ${ad}`,
    eslesmeGuveni: (yuzde: string) => `Eşleşme güveni: ${yuzde}`,
    izlenmiyor: "henüz izlenmiyor",
    merkezIzliyor: "merkez izliyor",
    katalogTazeligi: (an: string) => `Katalog tazeliği: ${an}`,
    bulamadim: "Bulamadım — elle değerlenen varlık olarak kaydet",
  },
  /** Varlık bağlama alanı (`components/AssetBindingField.tsx`). */
  baglama: {
    varlik: "Varlık",
    tur: "Bağlama türü",
    turIzlenen: "İzlenen araç (merkezden fiyatlanır)",
    turElle: "Elle değerlenen varlık",
    aracAra: "Araç ara",
    aracAraIpucu: "Merkezin kataloğunda arayın ve adaylardan doğru olanı seçin.",
    paraBirimiOnEk: " · Para birimi: ",
    baskaArac: "Başka araç seç",
    izlemeyeAliniyor: "Araç izlemeye alınıyor…",
    cozulemediBaslik: "Bu araç çözülemedi — elle değerleme gerekiyor",
    elleyeCevir: "Elle değerlenen varlığa çevir",
    ilerlemeOnce: "İlerlemeyi ",
    ilerlemeEkran: "İzleme",
    ilerlemeSonra: " ekranından izleyebilirsiniz.",
    alinamadiBaslik: "İzlemeye alınamadı",
    alinamadiMetin:
      "Hareketi yine kaydedebilirsiniz — kasa merkeze bağlı değildir. Araç, merkeze ulaşıldığında İzleme ekranından izlemeye alınabilir.",
    merkezsizDevam: "Merkez olmadan devam et: araç kimliğini elle yaz",
    aracKimligi: "Araç kimliği",
    aracKimligiIpucu: "Merkezin kanonik kimliği (örn. BIST:THYAO). Yanlış kimlik yanlış fiyat demektir.",
    varlikEtiketi: "Varlık etiketi",
    etiketIpucu: "Elle değerleme ekranı bu etiketle eşleşir.",
    etiketOrnek: "Fiziki gram altın",
    varlikParaBirimi: "Varlık para birimi",
    paraBirimiBilinmiyor: "Merkez bu varlığın para birimini bilmiyor — listeden seçin.",
  },
};
